import React from 'react';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useQueueRegistry } from '../queues/queue-registry/use-queue-registry';
import { UnitTimersStore } from './unit-timers-store';
import { UnitTimersStoreContext } from './unit-timers-store-context';
import { useAudibleAlerts } from '../sounds/play-sound-provider';
import { useApplicationType } from '../common/hooks/use-application-type';

export function UnitTimersStoreProvider({
    unitTimersStore,
    children,
}: {
    unitTimersStore?: UnitTimersStore;
    children: React.ReactElement;
}): React.ReactElement {
    const queueRegistry = useQueueRegistry();
    const enabledFeatures = useEnabledFeatures();
    const { playAlert } = useAudibleAlerts();
    const { isCad } = useApplicationType();

    const value: UnitTimersStore = React.useState(
        () =>
            unitTimersStore ||
            new UnitTimersStore((unitId: number): void => {
                const unitQueueStore = queueRegistry
                    .getUnitQueueStores()
                    .find((queueStore) => queueStore.isRowInList(unitId));
                if (!unitQueueStore) {
                    return;
                }
                const unitRow = unitQueueStore.listStore.getItemById(unitId);
                playAlert({
                    type: 'UNIT_TIMER_EXPIRED',
                    context: { enabledFeatures, isCad },
                    agencyTypeGlobalAttrId: unitRow?.agencyTypeGlobalAttrId,
                });
            })
    )[0];
    return (
        <UnitTimersStoreContext.Provider value={value}>{children}</UnitTimersStoreContext.Provider>
    );
}
